import { PronunciationPractice } from "@/components/PronunciationPractice";

export const SpeakExercise = ({ ex, lang, locked, onSubmit }) => (
  <div>
    <PronunciationPractice
      key={ex.text}
      text={ex.text}
      romaji={ex.romaji}
      lang={lang}
      testPrefix="speak-exercise"
      onResult={(r) => !locked && onSubmit(r.score >= 60, ex.text, `Score ${r.score}/100. ${r.feedback}`)}
    />
    {!locked && (
      <button data-testid="speak-exercise-skip-button" onClick={() => onSubmit(null)} className="w-full mt-6 text-sm font-semibold text-slate-500 hover:text-slate-800">
        Can't speak right now, skip
      </button>
    )}
  </div>
);
